export type ReportPopulationState = {
  includeTestRows: boolean;
  includeInactiveEpisodes: boolean;
};

export function buildReportPopulationQuery({
  includeTestRows,
  includeInactiveEpisodes,
}: ReportPopulationState) {
  return {
    include_test_rows: includeTestRows,
    include_inactive_episodes: includeInactiveEpisodes,
  };
}
